import Marquee from "react-fast-marquee";

const items = [
  "ANTS DON'T SLEEP",
  "BOOKING: 772-332-4038",
  "RAW TECHNO",
  "NO GENRE — NO MERCY",
  "WAREHOUSE READY",
];

export default function Ticker() {
  return (
    <div
      className="border-b border-white/15 bg-black py-4 overflow-hidden"
      data-testid="ticker"
    >
      <Marquee speed={38} gradient={false} pauseOnHover>
        {items.concat(items).map((t, i) => (
          <span
            key={i}
            className="font-mono-x text-sm sm:text-base tracking-[0.3em] uppercase mx-8 whitespace-nowrap"
          >
            <span className={i % 2 ? "text-stroke" : "text-white/80"}>{t}</span>
            <span className="text-[#ff3b1d] ml-16">///</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
